import script from "./PCDManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./PCDManagementView.vue?vue&type=script&setup=true&lang=js"

import "./PCDManagementView.vue?vue&type=style&index=0&id=2089c13f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2089c13f"]])

export default __exports__